module.exports = __webpack_public_path__ + "static/media/background.6a3ba627.jpg";